export default "__VITE_ASSET__CBxe$Yvk__"